import { doorRules, type DoorTypeId } from '@planner/config';
import { LockDialog } from './LockDialog.js';

export function LockLayoutHelp({ doorType }: { doorType: DoorTypeId }) {
  const security = doorType === 'security';
  return (
    <LockDialog
      name="lock-layout"
      title={security ? 'Where your locks will sit' : 'Where your handle will sit'}
      triggerLabel={security ? 'See where your locks will sit' : 'See where your handle will sit'}
      triggerName="lock-layout-open"
      triggerClassName="mt-4 min-h-11 text-left text-xs font-semibold text-progress underline underline-offset-2 focus-visible:outline-2 focus-visible:outline-progress"
      trigger={security ? 'See where your locks will sit' : 'See where your handle will sit'}
    >
      {() => (
        <>
          <p className="mt-2 text-xs leading-relaxed text-gray-500">
            {security
              ? `The top lock is ${doorRules.securityLockOffsets.top} mm above the handle; the bottom lock is ${doorRules.securityLockOffsets.bottom} mm below it.`
              : 'A Barrier door has one lock at the handle.'}
          </p>
          <svg
            viewBox="0 0 300 330"
            className="mx-auto mt-4 h-auto w-full max-w-64"
            role="img"
            aria-label={
              security ? 'Illustrative triple-lock layout' : 'Illustrative single-lock layout'
            }
          >
            <rect
              x="95"
              y="20"
              width="100"
              height="270"
              fill="white"
              stroke="#374151"
              strokeWidth="2"
            />
            <rect x="103" y="28" width="84" height="254" fill="#F3F4F6" stroke="#9CA3AF" />
            {[42, 155, 268].map((y) => (
              <rect key={y} x="195" y={y - 7} width="5" height="14" fill="#374151" />
            ))}
            {security && (
              <>
                <circle cx="102" cy="58" r="5" fill="var(--brand-progress)" />
                <circle cx="102" cy="255" r="5" fill="var(--brand-progress)" />
                <text x="84" y="61" fontSize="10" textAnchor="end" fill="#374151">
                  Top lock
                </text>
                <text x="84" y="258" fontSize="10" textAnchor="end" fill="#374151">
                  Bottom lock
                </text>
                <text x="208" y="105" fontSize="10" fill="#C2410C">
                  +{doorRules.securityLockOffsets.top} mm
                </text>
                <text x="208" y="220" fontSize="10" fill="#C2410C">
                  −{doorRules.securityLockOffsets.bottom} mm
                </text>
              </>
            )}
            <rect x="99" y="141" width="7" height="28" rx="2" fill="white" stroke="#374151" />
            <rect
              x="102"
              y="152"
              width="25"
              height="6"
              rx="3"
              fill="white"
              stroke="var(--brand-progress)"
            />
            <circle cx="102" cy="155" r="3" fill="var(--brand-progress)" />
            <text x="84" y="158" fontSize="10" textAnchor="end" fill="#374151">
              Handle
            </text>
            <line x1="65" y1="290" x2="225" y2="290" stroke="#9CA3AF" />
            <text x="145" y="307" fontSize="8" textAnchor="middle" fill="#9CA3AF">
              BOTTOM OF DOOR
            </text>
          </svg>
          <p className="mt-3 text-xs leading-relaxed text-gray-600">
            Three hinges: {doorRules.hinges.edgeOffsetMm} mm from each end and one at mid-height.
            Illustrative only; not to scale.
          </p>
        </>
      )}
    </LockDialog>
  );
}
